/** Query types a Products block's own "Marki" filter narrows. `current_category` lists the catalog
 *  with the visitor's own filters (which can include brands), so the block doesn't add its own there. */
export const BRAND_FILTER_QUERY_TYPES = ['latest', 'category', 'sale'] as const;

export function blockBrandSlugs(queryType: string, brandSlugs: unknown): string[] {
    if (!(BRAND_FILTER_QUERY_TYPES as readonly string[]).includes(queryType)) return [];
    return Array.isArray(brandSlugs)
        ? brandSlugs.filter((s): s is string => typeof s === 'string' && s.trim() !== '').map((s) => s.trim())
        : [];
}

/** `f.@brand=nike,next` — the catalog facet the backend already filters by (shop/logic/catalog_index.py),
 *  shared by ProductGrid's client fetch and serverPrefetch so both ask for the same products. */
export function appendBlockBrandFilter(params: URLSearchParams, queryType: string, brandSlugs: unknown): void {
    const slugs = blockBrandSlugs(queryType, brandSlugs);
    if (slugs.length) params.append('f.@brand', slugs.join(','));
}
